export const AVATAR_API_HOSTS = {
  dev: process.env.REACT_APP_AVATAR_API_DEV,
  prod: process.env.REACT_APP_AVATAR_API,
};

export const QUESTIONNAIRE_API_HOSTS = {
  dev: process.env.REACT_APP_QUESTIONNAIRE_API_DEV,
  prod: process.env.REACT_APP_QUESTIONNAIRE_API,
};

export const HOSTNAMES = {
  dev: process.env.REACT_APP_HOSTNAME_DEV,
  prod: process.env.REACT_APP_HOSTNAME,
};

export const PUBLIC_URL = {
  dev: process.env.REACT_APP_PUBLIC_URL_RATINGS_AND_REVIEWS_DEV,
  prod: process.env.REACT_APP_PUBLIC_URL_RATINGS_AND_REVIEWS,
};
